import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  NewTermCondition,
  OfferHotel,
  PropertySelection,
} from "shared/components";
import { notifySuccess } from "shared/components/A_New_Components/ToastNotification";
import { addHotel } from "shared/services";
import styles from "./style.module.css";
import commonstyle from "shared/utils/common.module.css";
import { useFormik } from "formik";
import { setHotelInfo } from "shared/redux";
import * as Yup from "yup";
import { useLocation, useNavigate } from "react-router-dom";
import CustomLoader from "shared/components/New_Loader/Loader";
import { useTranslation } from "react-i18next";

const formikvalidationSchema = (t: any) =>
  Yup.object({
    property: Yup.string().required(t("propertyRequired")),
    propertyName: Yup.string()
      .required(t("propertNameRequied"))
      .min(3, t("propertyNameMustBeAtleast_")),
    contactNumber: Yup.string().required(t("contactNumberRequired")),
    numberOfBeds: Yup.number()
      .required(t("numberOfBedsRequired"))
      .min(1, t("numberOfBedsAtleast1_"))
      .integer(t("numberOfBedsMustWholeNumber")),
    noOfGuests: Yup.number()
      .required(t("numberOfGuestsRequired"))
      .min(1, t("numberOfGuestssAtleast1_"))
      .integer(t("numberOfGuestsMustWholeNumber")),
    bathroomscount: Yup.number()
      .required(t("numberOfBathroomsRequired"))
      .min(1, t("numberOfBathroomssAtleast1_"))
      .integer(t("numberOfBathroomsMustWholeNumber")),
    bathroomstype: Yup.string().required(t("bathroomTypeRequired")),
    propertyDetails: Yup.string().required(t("bathroomTypeRequired")),
    address: Yup.string().when("property", {
      is: (value: any) => value === "suite" || value === "rooms",
      then: (schema) => schema.notRequired(),
      otherwise: (schema) => schema.required(t("addressIsRequired")),
    }),
    city: Yup.string().when("property", {
      is: (value: any) => value === "suite" || value === "rooms",
      then: (schema) => schema.notRequired(),
      otherwise: (schema) => schema.required(t("cityIsRequired")),
    }),
  });

const validationSchema = (t: any) =>
  Yup.object({
    features: Yup.array()
      .min(1, t("selectAtleastOneFeature"))
      .required(t("featuresRequired")),
    parking: Yup.string().required(t("parkingOptionRequired")),
    propertyCount: Yup.string().required(t("propertyCountRequired")),
    checkInTime: Yup.string().required(t("checkInTImeReqired")),
    checkOutTime: Yup.string().required(t("checkOutTImeReqired")),
    propertyRent: Yup.string().required(t("propertyRentRequired")),
    meditourFee: Yup.string().required(t("meditourFeeReqired")),
    smoking: Yup.string().required(t("smokingOptionRequired")),
    pets: Yup.string().required(t("petsOptionRequired")),
    extraBeds: Yup.string().required(t("extrBedsOptionRequired")),
    safetyDetails: Yup.array()
      .min(1, t("selectAteast_1_SafetyDetail"))
      .required(t("safetyDetailsRequired")),
    sorroundingProperty: Yup.string().required(
      t("SurroundingPropertyRequired")
    ),
    propertyphotos: Yup.array()
      .min(1, t("pleaseUploadAtleast_1_Photo"))
      .required(t("propertyPhotosRequired")),
  });

const termvalidationSchema = (t: any) =>
  Yup.object({
    paymentMethods: Yup.array()
      .min(1, t("atLeast_1_PaymentMethod"))
      .required(t("paymentMethodRequired")),
    cancellationWindow: Yup.string()
      .oneOf(["24hr", "36hr", "48hr"], t("invalidCancellationWindow_"))
      .required(t("cancellationWindowRequired")),
  });

const AddProperty = () => {
  const { t, i18n }: any = useTranslation();
  const [currentStep, setCurrentStep] = useState(0);
  const [loading, setloading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { hotelInfo, user } = useSelector((state: any) => state?.root?.common);
  const location = useLocation();
  const { id } = location?.state;
  const hotelAdd = (val: any) => {
    setloading(true);
    const params = {
      // hotelId: id ? id : user?._id,
      property: hotelInfo?.property,
      propertyName: hotelInfo?.propertyName,
      contactNumber: hotelInfo?.contactNumber,
      numberOfBeds: hotelInfo?.numberOfBeds,
      noOfGuests: hotelInfo?.noOfGuests,
      noOfBathrooms: {
        count: hotelInfo?.bathroomscount,
        type: hotelInfo?.bathroomstype?.toLowerCase(),
      },
      propertyDetails: hotelInfo?.propertyDetails,
      features: hotelInfo?.data?.features,
      propertyCount: hotelInfo?.data?.propertyCount,
      checkInTime: hotelInfo?.data?.checkInTime,
      propertyRent: hotelInfo?.data?.propertyRent,
      meditourFee: hotelInfo?.data?.meditourFee,
      smoking: hotelInfo?.data?.smoking === "Not Allowed" ? false : true,
      pets: hotelInfo?.data?.pets === "Not Allowed" ? false : true,
      extraBeds: hotelInfo?.data?.extraBeds === "Not Allowed" ? false : true,
      safetyDetails: hotelInfo?.data?.safetyDetails,
      sorroundingProperty: hotelInfo?.data?.sorroundingProperty,
      propertyphotos: hotelInfo?.data?.propertyphotos,
      paymentMethods: val?.paymentMethods,
      checkOutTime: hotelInfo?.data?.checkOutTime,
      cancellationWindow: val?.cancellationWindow,
      parking: hotelInfo?.data?.parking == "Allowed" ? true : false,
      ...(hotelInfo?.property !== "suite" && hotelInfo?.property !== "rooms"
        ? {
            location: {
              lng: hotelInfo?.lng ?? 0,
              lat: hotelInfo?.lat ?? 0,
              address: hotelInfo?.address ?? "",
              city: hotelInfo?.city ?? "",
            },
          }
        : {}),
    };
    let hID = id ? id : user?._id;
    addHotel(hID, params)
      .then(() => {
        notifySuccess(t("propertyAddedSuccessfully"));
        dispatch(setHotelInfo({}));

        let url = id ? "/greenFlag/ManageHotels" : "/hotel/Property";

        navigate(url);
      })
      .catch(() => {})
      .finally(() => {
        setloading(false);
      });
  };

  const formik = useFormik({
    initialValues: {
      property: "",
      propertyName: "",
      contactNumber: "",
      numberOfBeds: 1,
      noOfGuests: 1,
      bathroomscount: 1,
      bathroomstype: "",
      propertyDetails: "",
      address: "",
      lng: "",
      lat: "",
      city: "",
    },
    validationSchema: formikvalidationSchema(t),
    onSubmit: (values) => {
      handleNext(values);
    },
  });
  const handleNext = (data: any) => {
    dispatch(setHotelInfo(data));
    setCurrentStep(1);
  };

  // .............secound.....................................................................................
  const offer = useFormik({
    initialValues: {
      features: [],
      parking: "",
      propertyCount: "",
      checkInTime: "",
      propertyRent: "",
      meditourFee: "",
      smoking: "",
      pets: "",
      checkOutTime: "",
      extraBeds: "",
      safetyDetails: [],
      sorroundingProperty: "",
      propertyphotos: [],
    },
    validationSchema: validationSchema(t),
    onSubmit: (values) => {
      handleValues(values);
    },
  });

  const handleValues = (data: any) => {
    const features = {
      ...hotelInfo,
      data,
    };
    dispatch(setHotelInfo(features));
    setCurrentStep(2);
  };

  //  ..................................////////////////.........................................................................
  const termFormik: any = useFormik({
    initialValues: {
      paymentMethods: [],
      cancellationWindow: "24hr",
    },
    validationSchema: termvalidationSchema(t),
    onSubmit: (values) => {
      hotelAdd(values);
    },
  });

  useEffect(() => {
    offer.validateForm();
    formik.validateForm();
    termFormik.validateForm();
  }, [i18n.language]);

  const handleMove = () => {
    if (currentStep == 0) {
      formik.handleSubmit();
    } else if (currentStep == 1) {
      offer.handleSubmit();
    } else {
      termFormik.handleSubmit();
    }
  };
  return (
    <div
      className={
        ["ur", "ar", "ps", "pr"].includes(i18n.language)
          ? commonstyle.pl36
          : commonstyle.pr36
      }
    >
      <div className={styles.container}>
        {currentStep === 0 ? (
          <PropertySelection formik={formik} />
        ) : currentStep === 1 ? (
          <OfferHotel formik={offer} />
        ) : (
          <NewTermCondition formik={termFormik} />
        )}
        <div className={styles.progressBarContainer}>
          <div
            className={styles.progressBar}
            style={{ width: `${(currentStep / 2) * 100}%` }}
          ></div>
        </div>
        <div className={styles.buttonRow}>
          <button
            className={styles.backButton}
            onClick={() => {
              if (currentStep === 0) {
                let url = id ? "/greenFlag/ManageHotels" : "/hotel/Property";

                navigate(url);
                // navigate("/hotel/Property");
              } else {
                setCurrentStep((prev) => prev - 1);
              }
            }}
          >
            {t("back")}
          </button>
          <button
            type="submit"
            className={styles.nextButton}
            onClick={handleMove}
            disabled={loading}
          >
            {currentStep === 2 ? t("finish") : t("next")}
          </button>
        </div>
        {loading && <CustomLoader />}
      </div>
    </div>
  );
};

export default AddProperty;
